import React from "react";
import DashboardShape3 from "../dashboard/components/DashboardShape3";
import ChartCard from "./components/ChartCard";
import PastSales from "./components/PastSales";
import StateShape1 from "./components/StateShape1";
const data = [
	{
		subtext: "Successful Sales",
		title: "598",
	},
	{
		subtext: "Total Raised on yLanuch",
		title: "1,506,787 ALGO",
	},
	{
		subtext: "Total Participants",
		title: "1,078",
	},
	{
		subtext: "Registered Users",
		title: "604",
	},
	{
		subtext: "Total KYC Completed",
		title: "600",
	},
	{
		subtext: "Verified Wallets",
		title: "604",
	},
];

const chart__data = {
	label: ["YAY", "KLO", "HCT", "ROCO", "OH", "CRA"],
	dataSet: [3000, 7000, 6000, 8000, 10000.6, 12000],
};

const Stats = () => {
	return (
		<section className="dashboard-section __stats-section">
			<div className="dashboard-shape">
				<StateShape1 />
			</div>
			<div className="dashboard-shape-3">
				<DashboardShape3 />
			</div>
			<div className="container">
				<div className="section-title">
					<h2 className="title">Stats</h2>
				</div>
				<div className="row g-3 __g-4">
					{data.map(({ subtext, title }, i) => (
						<div className="col-lg-4 col-sm-6" key={i}>
							<StateCard subtext={subtext} title={title} />
						</div>
					))}
				</div>
			</div>
			<div className="pt-95px">
				<div className="container">
					<div className="row g-4 __g-4">
						<div className="col-lg-6">
							<ChartCard
								title="Total Raised per Project ($)"
								data={chart__data}
							/>
						</div>
						<div className="col-lg-6">
							<ChartCard
								title="Total Raised per Project ($)"
								data={chart__data}
							/>
						</div>
					</div>
				</div>
			</div>
			<PastSales />
		</section>
	);
};
export const StateCard = ({ subtext, title }) => {
	return (
		<>
			<div className="state__card">
				<div className="subtext">{subtext}</div>
				<h4 className="title">{title}</h4>
			</div>
		</>
	);
};
export default Stats;
